module.exports = new __parcel__URL__("services_2.6d1c872e.jpg").toString();